import {IconButton, Stack} from "@mui/material";
import {copyToClipboard} from "../../../utils/Clipboard";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import React from "react";
import {useAuthStore} from "../../../store/auth.store";

export function TelegramInstruction() {
    const {can} = useAuthStore();
    if(!can('see_premium')) {
        return null;
    }
    return <Stack>
        <span>If you want to publish advertisements to your Telegram group, supergroup, or channel, first add bot&nbsp;
            <b>@relapka_bot</b>
            <IconButton
                onClick={() => copyToClipboard("@relapka_bot")}>
                <ContentCopyIcon color={"success"}/>
            </IconButton>
            to that chat. For channels, grant admin privileges. For groups, make sure the bot is allowed to send messages.</span>
    </Stack>
}